export default "__VITE_ASSET__e7554e52__"